<template>
  <div>
    <classification
      v-if="hasOnlyOne"
      class="classification-type__label"
      :classification="classification"
      :displaying="displaying"
    />
    <b-button
      v-else
      class="classification-type__link text-nowrap"
      variant="link"
      @click="onClickLinkHandler()"
    >
      {{ label }}
    </b-button>
  </div>
</template>

<script>
import Classification from './Classification';

export default {
  components: {
    Classification,
  },
  props: {
    displaying: {
      type: Boolean,
      default: true,
    },
    classifications: {
      type: Array,
      required: true,
    },
  },
  computed: {
    classification() {
      const [classification] = this.classifications;
      return classification || '';
    },
    hasOnlyOne() {
      return (this.classifications || []).length === 1;
    },
    label() {
      const amount = (this.classifications || []).length;
      return `+${amount}`;
    },
  },
  methods: {
    onClickLinkHandler() {
      this.$emit('click-link');
    },
  },
};
</script>

<style lang="sass" scoped>
  .classification-type
    &__link
      padding: 0
      color: var(--color-info)
      text-decoration: underline
      cursor: pointer
      &:hover
        color: var(--color-info)
</style>
